export interface ICheckoutForm {
  success: boolean
}

export const submitForm = async (form: HTMLFormElement): Promise<ICheckoutForm> => {
  const formData = new FormData(form)
  //@ts-ignore
  const dataString = new URLSearchParams(formData).toString()

  const response = await fetch(form.getAttribute('action'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: dataString
  })

  if (response) {
    const data = await response.json()

    return data
  }
}
